import axios from '@/axios.js'
import { QuerySerialize } from '@/utils'
import { notifyServerError, notifyWarning } from '@/layouts/notifies'
import i18n from '@/i18n/i18n'

export default {
  createSurvey(context, surveyData) {
    return new Promise((resolve, reject) => {
      axios
        .post('surveys', surveyData)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          if (error.response.status === 409) notifyWarning(i18n.t('server.error.request_already_surveyed'))
          else notifyServerError(error)
          reject(error)
        })
    })
  },
  countSurveys(context, payload = { query: {} }) {
    const query = QuerySerialize(payload.query)
    return new Promise((resolve, reject) => {
      axios
        .get(`surveys/count/?${query}`)
        .then(response => {
          context.commit('SET_SURVEY_COUNT', response.data)
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  fetchSurveys(context, payload = { skip: 0, limit: 0, query: {} }) {
    const query = QuerySerialize(payload.query)
    return new Promise((resolve, reject) => {
      axios
        .get(`surveys/?skip=${payload.skip}&limit=${payload.limit}&${query}`)
        .then(response => {
          context.commit('SET_SURVEY', response.data)
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  fetchSurvey(context, surveyId) {
    return new Promise((resolve, reject) => {
      axios
        .get(`surveys/${surveyId}`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  removeSurvey({ commit }, surveyId) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`surveys/${surveyId}`)
        .then(response => {
          commit('REMOVE_RECORD', surveyId)
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  editSurvey(context, survey) {
    return new Promise((resolve, reject) => {
      axios
        .put(`surveys/${survey.id}`, survey.data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  editSurveyState(context, survey) {
    return new Promise((resolve, reject) => {
      axios
        .put(`surveys/${survey.id}/state`, survey.data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  }
}
